<template>
  <div class="dashboard-view">
    <div class="page-wrapper">
      <!-- Menu-->
      <div class="side-menu">
        <div v-if="isSso" class="logo-wrapper">
          <img src="@/assets/images/logo.png" class="logo" alt="Macha Logo" />
          <unicon name="setting" @click="$emit('showAdminSettings')"></unicon>
        </div>
        <SideMenu :menu="menu" :highlightExactRoute="false"></SideMenu>

        <!-- Re-Auth Card -->
        <ReAuthCard v-if="needsReAuth" />

        <!-- Trial Extension -->
        <TrialExtension
          v-else-if="subscription?.status === 'trial'"
          :marketplaceUrl="trialExtenstionContent.marketplaceUrl"
          :steps="trialExtenstionContent.steps"
        ></TrialExtension>
      </div>

      <!-- Settings View-->
      <div class="page-content">
        <keep-alive
          ><router-view :reloadView="reloadView"></router-view
        ></keep-alive>
      </div>

      <!-- Loader-->
      <LineLoader :show="showOptions.lineLoader"></LineLoader>

      <!-- Notification Message-->
      <NotificationMessage
        :show="status.show"
        :status="status.status"
        :title="status.title"
      ></NotificationMessage>
    </div>
  </div>
</template>

<script>
// Libraries
import _ from "lodash";

// Components
import SideMenu from "@/components/dashboard/SideMenu";
import TrialExtension from "@/components/dashboard/subscription/trial/Extension";
import ReAuthCard from "@/components/dashboard/ReAuthCard";
import NotificationMessage from "@/components/modals/NotificationMessage";
import LineLoader from "@/components/loaders/LineLoader";

// Defaults
import { APP_NAMES } from "@/mixins/Variables";

// Services
import { TranslationsAppService } from "@/services";
const { CompanyService } = TranslationsAppService;

export default {
  name: "AiTranslations",
  data() {
    return {
      lodash: _,
      reloadView: false,
      showOptions: {
        lineLoader: false,
        preLoader: false,
      },
      menu: [
        {
          name: "AI Translations",
          type: "category",
          menuItems: [
            {
              name: "Home",
              icon: "inbox",
              path: "/apps/translations/home",
            },
            {
              name: "Settings",
              icon: "setting",
              path: "/apps/translations/settings",
            },
            {
              name: "Agents",
              icon: "users-alt",
              path: "/apps/translations/agents",
            },
            {
              name: "Analytics",
              icon: "analytics",
              path: "/apps/translations/analytics",
            },
            {
              name: "Subscription",
              icon: "globe",
              path: "/apps/translations/subscription",
            },
          ],
        },
      ],
      trialExtenstionContent: {
        marketplaceUrl:
          "https://www.zendesk.com/marketplace/apps/support/1166071",
        steps: {
          title: "How to extend your trial",
          list: [
            'Scroll down to reviews <a href="https://www.zendesk.com/marketplace/apps/support/1166071" target="_blank">here</a>',
            'Select Zendesk account from dropdown beside "What people are saying"',
            "Scroll to reviews section and review",
            `<a href="mailto:support@getmacha.com?subject=AI%20Ticket%20Translations%20-%20Add%20free%201%20week%20extension%20to%20my%20trial&body=Hey%20We've%20left%20a%20review%20for%20Macha%20on%20Zendesk%20and%20would%20like%20our%20free%201%20week%20trial%20extension.%20Thanks">Mail us</a> and let us know`,
          ],
        },
      },
      status: {
        show: false,
        status: "success",
        title: "Widget saved",
      },
      saveInProgress: false,
    };
  },
  components: {
    SideMenu,
    TrialExtension,
    ReAuthCard,
    NotificationMessage,
    LineLoader,
  },
  computed: {
    company() {
      return this.$store.getters.company;
    },
    selectedApp() {
      return this.$store.getters.selectedApp;
    },
    subscription() {
      return this.selectedApp?.subscription;
    },
    isSso() {
      return this.$store.getters.isSso;
    },
    needsReAuth() {
      const creds = this.company?.integrations?.zendesk?.credentials;
      // Show re-auth if refresh failed OR if we have subdomain but no tokens
      return creds?.refreshTokenFailed === true ||
        (creds?.subdomain && !creds?.accessToken);
    },
  },
  async created() {
    this.checkActivation();
  },
  methods: {
    async checkActivation() {
      const data = { companyId: this.company._id };
      const response = await CompanyService.GetCompany(data);

      if (response.hasError || _.isEmpty(response.data)) {
        const redirectRoute = "/apps/translations/activation";
        this.$router.push({ path: `${redirectRoute}` });
      }

      this.$store.commit("updateSelectedApp", {
        appName: APP_NAMES.translations,
        ...response.data,
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/shared/dashboard.scss";

::v-deep .page-header {
  margin-bottom: 3rem;
}
::v-deep .line-loader {
  position: fixed;
  z-index: 101;
  bottom: 0;
  left: 0;
}
</style>
